import React from "react";
import Carousel from "react-material-ui-carousel";
import { Container, makeStyles } from "@material-ui/core";
import "./weOfferSlide.css";

const useStyles = makeStyles((theme) => ({
  image: {
    width: "100%",
    height: "230px",
    objectFit: "cover",
    borderRadius: "8px",
  },
}));

const WeOfferSlider = ({ offers }) => {
  const classes = useStyles();

  return (
    <Container className="weOfferSlider">
      <Carousel>
        {offers.map((offer) => {
          return (
            <div key={offer.title}>
              <img
                src={offer.image}
                className={classes.image}
                height="100%"
                width="100%"
                alt="offers"
              ></img>
            </div>
          );
        })}
      </Carousel>
    </Container>
  );
};

export default WeOfferSlider;
